
import { toast as sonnerToast } from "sonner";

export type ToastT = {
  id: string;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  variant?: "default" | "destructive";
  [key: string]: any;
};

type ToastProps = {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
  // Spreading any other props from sonner toast
  [key: string]: any;
};

export function useToast() {
  const toast = ({ title, description, variant = "default", ...props }: ToastProps) => {
    try {
      sonnerToast(title, {
        description,
        className: variant === "destructive" ? "destructive" : "",
        ...props,
      });
    } catch (error) {
      console.error("Error showing toast:", error);
    }
  };

  return {
    toast,
    toasts: [] // Always provide a default empty array
  };
}

// Export toast function directly with error handling
export const toast = (...args: Parameters<typeof sonnerToast>) => {
  try {
    return sonnerToast(...args);
  } catch (error) {
    console.error("Error showing toast:", error);
    return "";
  }
};
